const BASE_OFFSET = 4;

const adjustOverflow = {
  adjustX: false,
  adjustY: false,
};

const positions = {
  left: {
    points: ['cr', 'cl'],
    overflow: adjustOverflow,
    offset: [-4 * BASE_OFFSET, -0.5 * BASE_OFFSET],
  },
  right: {
    points: ['cl', 'cr'],
    overflow: adjustOverflow,
    offset: [4 * BASE_OFFSET, -0.5 * BASE_OFFSET],
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: adjustOverflow,
    offset: [-1 * BASE_OFFSET, -4 * BASE_OFFSET],
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: adjustOverflow,
    offset: [-1 * BASE_OFFSET, 4 * BASE_OFFSET],
  },
  topEnd: {
    points: ['br', 'tr'],
    overflow: adjustOverflow,
    offset: [BASE_OFFSET, -4 * BASE_OFFSET],
  },
  topStart: {
    points: ['bl', 'tl'],
    overflow: adjustOverflow,
    offset: [-BASE_OFFSET, -4 * BASE_OFFSET],
  },
  bottomEnd: {
    points: ['tr', 'br'],
    overflow: adjustOverflow,
    offset: [BASE_OFFSET, 4 * BASE_OFFSET],
  },
  bottomStart: {
    points: ['tl', 'bl'],
    overflow: adjustOverflow,
    offset: [-BASE_OFFSET, 4 * BASE_OFFSET],
  },
};

export default positions;
